import { render, staticRenderFns } from "./CPageHeader.vue?vue&type=template&id=079dbaff&scoped=true"
import script from "./CPageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CPageHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CPageHeader.vue?vue&type=style&index=0&id=079dbaff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079dbaff",
  null
  
)

export default component.exports